/* eslint-disable jsx-a11y/alt-text */
import styled from 'styled-components'
import { SvgIcon } from '@/components'
import OverviewLine from '@/assets/imges/phishing/create/overview_line.png'
import OverviewLine3 from '@/assets/imges/phishing/create/overview_line3.png'
import { t } from '@/i18n'
export const TaskNameRight = () => (
  <TaskTemplate>
    <div className="task">
      <Svg name={'phishing-task-name'} />
      <p className="text">{t('填写钓鱼邮件任务的名称')}</p>
    </div>
    <div className="task-main">
      <div className="task-border" />
    </div>
    <div className="task">
      <Svg name={'phishing-task-start'} />
      <p className="text">{t('选择任务开始时间')}</p>
    </div>
    <div className="task-main">
      <div className="task-border" />
    </div>
    <div className="task">
      <Svg name={'phishing-task-run'} />
      <p className="text">{t('请为任务制定一个合适的运行时长')}</p>
    </div>
    <div className="task-main">
      <SvgIcon name={'sort'} style={{ width: 24, height: 35 }} />
    </div>
    <div className="task">
      <Svg name={'phishing-task-target'} />
      <p className="text">{t('选择需要的评估目标')}</p>
    </div>
    {/* <img src={OverviewLine} alt="" style={{ width: '100%', height: 2 }} /> */}
    {/* <div>
     <div className="hint">注意：</div>
     <div className="hint">如果邮件网关白名单策略中未添加IP，可能导致：</div>
     <div className="hint">1.您的员工无法收到电子邮件</div>
     <div className="hint">2.电子邮件中的附件被杀</div>
    </div> */}
  </TaskTemplate>
)

export const TaskTargetRight = () => (
  <TaskTemplate>
    <div className="task">
      <Svg name={'phishing-task-target'} />
      <p className="text">{t('选择需要的评估目标')}</p>
    </div>
  </TaskTemplate>
)

export const TaskTypeRight = () => (
  <>
    <TaskTemplate>
      <div className="task">
        <Svg name="phishing-task-accessory" />
        <p className="text">
          {t('系统将向目标邮箱发送无害化处理的附件，以测试用户是否会打开钓鱼邮件的附件。')}
        </p>
      </div>
      <div className="task">
        <Svg name="phishing-task-phishing" />
        <p className="text">
          {t(
            '系统将向目标邮箱发送的邮件正文中含有无害化处理的钓鱼链接，以测试用户是否会点击钓鱼链接并提交敏感信息。',
          )}
        </p>
      </div>
    </TaskTemplate>
    <img src={OverviewLine3} alt="" style={{ width: '100%', height: 2 }} />
    <div style={{ fontSize: 16, fontWeight: 600, paddingTop: 20 }}>{t('发件地址')}</div>
    <TaskTemplate>
      <div className="task">
        <Svg name="phishing-task-address" />
        <p className="text">{t('可使用自定义的发件服务器地址，可能无法判断发件状态；')}</p>
      </div>
      <div style={{ display: 'flex' }}>
        <div style={{ width: 60 }} />
        <p className="text">{t('若发件服务器异常可能会导致任务异常。')}</p>
      </div>
    </TaskTemplate>
  </>
)

export const TaskAccessoryRight = () => (
  <TaskTemplate>
    <div className="task">
      <Svg name="phishing-task-accessory" />
      <p className="text">{t('为本次钓鱼邮件任务选取合适的策略模板')}</p>
    </div>
  </TaskTemplate>
)

export const TaskPhishingRight = () => (
  <TaskTemplate>
    <div className="task">
      <Svg name="phishing-task-phishing" />
      <p className="text">{t('为本次钓鱼邮件任务选取合适的策略模板')}</p>
    </div>
  </TaskTemplate>
)

export const TaskPhishRight = () => (
  <TaskTemplate>
    <div className="task">
      {/* <Svg name="phishing-task-phish" /> */}
      <Svg name="phishing-task-spite" />
      <p className="text">{t('可选择不同类型的钓鱼页面，建议选择最佳搭配的页面。')}</p>
    </div>
  </TaskTemplate>
)

export const TaskAccessory = () => (
  <TaskTemplate>
    <div className="task">
      <Svg name="phishing-task-email" />
      <div style={{ flex: 1 }}>
        <p className="text">{t('为任务定制具有迷惑性的发件人及邮箱地址')}</p>
        <p className="text" style={{ marginTop: 10, color: '#999' }}>
          {t(
            '如：总经理办公室<office@example.com>可对邮件内容进行编辑以增加迷惑性，支持通过编辑器“源码”功能编辑HTML代码。',
          )}
        </p>
      </div>
    </div>
    <div style={{ marginBottom: 16, color: '#666', marginTop: 10 }}>{t('可用变量及释义：')}</div>
    <div className="task">
      <div className="content">
        <p
          className="text"
          style={{ color: '#999', lineHeight: 1.5, whiteSpace: 'pre-line', fontSize: 12 }}
        >
          {t(
            '{{.Url}}，钓⻥邮件链接，如https://nomorephish.cn/phished.html\n如需统计点击链接的数量，必须添加此变量\n{{.DateCN}}，邮件发送日期，如2022年06月22日\n{{.Date}}，邮件发送日期，如2022-02-16\n{{.DateTime}}，邮件发送时间，如2022-02-16 01:23:34\n{{.Years}}，邮件发送年份，如2022\n{{.Mail}}，收件人邮箱地址，如zhangsan@example.com\n{{.Name}}，收件人邮箱前缀，如zhangsan, jack.ma\n{{.CNName}}，收件人中文名称，如张三\n{{.Date+Day}}，邮件发送日期后Day天，如当前为2022-02-16，{{.Date+5}}为{{2022-02-21}}\n{{.Date-Day}}，邮件发送日期前Day天，如当前为2022-02-16，{{.Date-5}}为{{2022-02-11}}\n{{.DateCN+Day}}，邮件发送日期后Day天，如当前为2022年02月16日，{{.DateCN+5}}为{{2022年02月21日}}\n{{.DateCN-Day}}，邮件发送日期前Day天，如当前为2022年02月16日，{{.DateCN-5}}为{{2022年02月11日}}\n{{.DateTime+Day}}，邮件发送日期后Day天，如当前为2022-02-16 01:23:34，{{.DateTime+5}}为2022-02-21 01:23:34\n{{.DateTime-Day}}，邮件发送日期前Day天，如当前为2022-02-16 01:23:34，{{.DateTime-5}}为2022-02-11 01:23:34',
          )}
        </p>
        {/* <p className="text" style={{ color: '#999' }}>{`{{.Date}}，邮件发送日期，如2022-02-16`}</p>
        <p className="text" style={{ color: '#999' }}>
         {`{{.Mail}}，收件人邮箱地址，如zhangsan@asants.com, jack.
        ma@asants.com`}
        </p>
        <p className="text" style={{ color: '#999' }}>
         {`{{.Name}}，收件人邮箱前缀，如zhangsan, jack.ma`}
        </p>
        <p className="text" style={{ color: '#999' }}>
         {`{{.URL}}，钓鱼邮件链接，如https://asants.com/phish`}
        </p> */}
      </div>
    </div>
  </TaskTemplate>
)

export const TaskEmailRight = () => (
  <TaskTemplate>
    <div className="task">
      <Svg name="phishing-task-email" />
      <div style={{ flex: 1 }}>
        <p className="text">{t('为任务定制具有迷惑性的发件人及邮箱地址')}</p>
        <p className="text" style={{ marginTop: 10, color: '#999' }}>
          {t(
            '如：总经理办公室<office@example.com>可对邮件内容进行编辑以增加迷惑性，支持通过编辑器“源码”功能编辑HTML代码。',
          )}
        </p>
      </div>
    </div>
    <div style={{ marginBottom: 16, color: '#666', marginTop: 10 }}>{t('可用变量及释义：')}</div>
    <div className="task">
      <div className="content">
        <p
          className="text"
          style={{ color: '#999', lineHeight: 1.5, whiteSpace: 'pre-line', fontSize: 12 }}
        >
          {t(
            '{{.Url}}，钓⻥邮件链接，如https://nomorephish.cn/phished.html\n如需统计点击链接的数量，必须添加此变量\n{{.QRCode}} 将对应的URL转换成二维码的形式\n{{.DateCN}}，邮件发送日期，如2022年06月22日\n{{.Date}}，邮件发送日期，如2022-02-16\n{{.DateTime}}，邮件发送时间，如2022-02-16 01:23:34\n{{.Years}}，邮件发送年份，如2022\n{{.Mail}}，收件人邮箱地址，如zhangsan@example.com\n{{.Name}}，收件人邮箱前缀，如zhangsan, jack.ma\n{{.CNName}}，收件人中文名称，如张三\n{{.Date+Day}}，邮件发送日期后Day天，如当前为2022-02-16，{{.Date+5}}为{{2022-02-21}}\n{{.Date-Day}}，邮件发送日期前Day天，如当前为2022-02-16，{{.Date-5}}为{{2022-02-11}}\n{{.DateCN+Day}}，邮件发送日期后Day天，如当前为2022年02月16日，{{.DateCN+5}}为{{2022年02月21日}}\n{{.DateCN-Day}}，邮件发送日期前Day天，如当前为2022年02月16日，{{.DateCN-5}}为{{2022年02月11日}}\n{{.DateTime+Day}}，邮件发送日期后Day天，如当前为2022-02-16 01:23:34，{{.DateTime+5}}为2022-02-21 01:23:34\n{{.DateTime-Day}}，邮件发送日期前Day天，如当前为2022-02-16 01:23:34，{{.DateTime-5}}为2022-02-11 01:23:34',
          )}
        </p>
        {/* <p className="text" style={{ color: '#999' }}>{`{{.Date}}，邮件发送日期，如2022-02-16`}</p>
        <p className="text" style={{ color: '#999' }}>
         {`{{.Mail}}，收件人邮箱地址，如zhangsan@asants.com, jack.
        ma@asants.com`}
        </p>
        <p className="text" style={{ color: '#999' }}>
         {`{{.Name}}，收件人邮箱前缀，如zhangsan, jack.ma`}
        </p>
        <p className="text" style={{ color: '#999' }}>
         {`{{.URL}}，钓鱼邮件链接，如https://asants.com/phish`}
        </p> */}
      </div>
    </div>
  </TaskTemplate>
)

export const AttachmentRight = () => (
  <TaskTemplate>
    <div className="task">
      <Svg name="phishing-task-email" />
      <div style={{ flex: 1 }}>
        <p className="text">{t('为任务定制具有迷惑性的发件人及邮箱地址')}</p>
        <p className="text" style={{ marginTop: 10, color: '#999' }}>
          {t(
            '如：总经理办公室<office@example.com>可对邮件内容进行编辑以增加迷惑性，支持通过编辑器“源码”功能编辑HTML代码。',
          )}
        </p>
      </div>
    </div>
    <div style={{ marginBottom: 16, color: '#666', marginTop: 10 }}>{t('可用变量及释义：')}</div>
    <div className="task">
      <div className="content">
        <p
          className="text"
          style={{ color: '#999', lineHeight: 1.5, whiteSpace: 'pre-line', fontSize: 12 }}
        >
          {t(
            '{{.Url}}，钓⻥邮件链接，如https://nomorephish.cn/phished.html\n如需统计点击链接的数量，必须添加此变量\n{{.DateCN}}，邮件发送日期，如2022年06月22日\n{{.Date}}，邮件发送日期，如2022-02-16\n{{.DateTime}}，邮件发送时间，如2022-02-16 01:23:34\n{{.Years}}，邮件发送年份，如2022\n{{.Mail}}，收件人邮箱地址，如zhangsan@example.com\n{{.Name}}，收件人邮箱前缀，如zhangsan, jack.ma\n{{.CNName}}，收件人中文名称，如张三\n{{.Date+Day}}，邮件发送日期后Day天，如当前为2022-02-16，{{.Date+5}}为{{2022-02-21}}\n{{.Date-Day}}，邮件发送日期前Day天，如当前为2022-02-16，{{.Date-5}}为{{2022-02-11}}\n{{.DateCN+Day}}，邮件发送日期后Day天，如当前为2022年02月16日，{{.DateCN+5}}为{{2022年02月21日}}\n{{.DateCN-Day}}，邮件发送日期前Day天，如当前为2022年02月16日，{{.DateCN-5}}为{{2022年02月11日}}\n{{.DateTime+Day}}，邮件发送日期后Day天，如当前为2022-02-16 01:23:34，{{.DateTime+5}}为2022-02-21 01:23:34\n{{.DateTime-Day}}，邮件发送日期前Day天，如当前为2022-02-16 01:23:34，{{.DateTime-5}}为2022-02-11 01:23:34',
          )}
        </p>
        {/* <p className="text" style={{ color: '#999' }}>{`{{.Date}}，邮件发送日期，如2022-02-16`}</p>
        <p className="text" style={{ color: '#999' }}>
         {`{{.Mail}}，收件人邮箱地址，如zhangsan@asants.com, jack.
        ma@asants.com`}
        </p>
        <p className="text" style={{ color: '#999' }}>
         {`{{.Name}}，收件人邮箱前缀，如zhangsan, jack.ma`}
        </p>
        <p className="text" style={{ color: '#999' }}>
         {`{{.URL}}，钓鱼邮件链接，如https://asants.com/phish`}
        </p> */}
      </div>
    </div>
  </TaskTemplate>
)

export const TaskEmailEncryption = () => (
  <TaskTemplate>
    <div className="title">{t('压缩加密')}</div>
    <div className="task">
      <Svg name="压缩加密" />
      <p className="text" style={{ whiteSpace: 'pre-line', color: '#558492', lineHeight: 1.5 }}>
        {t('使用方法：\n请在邮件正文中添加{{.ZipPwd}}，并输入压缩密码')}
      </p>
    </div>
    <div>
      <span style={{ color: '#F53F3F' }}>*</span>
      <span style={{ color: '#666', lineHeight: 1.2 }}>
        {t('为减少附件被邮件网关查杀的几率，可将附件压缩加密，密码将自动添加到邮件正文中')}
      </span>
    </div>
  </TaskTemplate>
)

export const TaskSpiteRight = () => (
  <TaskTemplate>
    <div className="task">
      <Svg name="phishing-task-spite" />
      <p className="text">
        {t(
          '可选择不同类型的恶意附件，建议选择最佳搭配的附件，系统内置附件均为经过无害化处理，可根据邮件内容修改附件名称，使邮件更加真实。',
        )}
      </p>
    </div>
  </TaskTemplate>
)

export const TaskRedirectRight = () => (
  <>
    <img src={OverviewLine} style={{ width: '100%', height: 1, margin: '24px 0' }} />
    <div style={{ marginBottom: 24, fontSize: 16, fontWeight: 600 }}>{t('重新定向的页面')}</div>
    <TaskTemplate>
      <div className="task">
        <Svg name="phishing-task-redirect" />
        <div style={{ flex: 1 }}>
          <p className="text">{t('被测试者在打开附件或钓鱼页面提交信息后需要跳转的页面地址')}</p>
          <p className="text">
            {t('如：')}
            <a
              // style={{ borderBottom: '1px solid #4238c9' }}
              style={{ color: '#031A79' }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://nomorephish.cn/phished.html"
            >
              https://nomorephish.cn/phished.html
            </a>
          </p>
          <p className="text">{t('对于纯钓鱼页该项不会起作用')}</p>
        </div>
      </div>
    </TaskTemplate>
  </>
)

export const TaskOverRight = () => (
  <>
    <TaskTemplate>
      <div className="task">
        <Svg name="phishing-task-over" />
        <div style={{ flex: 1 }}>
          <p className="text">
            {t('请确认任务相关配置，可选择任务结束后将评估报表自动发送至目标邮箱')}
          </p>
        </div>
      </div>
    </TaskTemplate>
    <img src={OverviewLine3} style={{ width: '100%', height: 2, margin: '24px 0' }} />
    <div style={{ marginBottom: 24, fontSize: 16, fontWeight: 600 }}>{t('发件地址')}</div>
    <TaskTemplate>
      <div className="task">
        <Svg name="phishing-task-address" />
        <div style={{ flex: 1 }}>
          <p className="text">{t('可使用自定义的发件服务器地址，可能无法判断发件状态；')}</p>
        </div>
      </div>
      <div style={{ display: 'flex' }}>
        <div style={{ width: 60 }} />
        <p className="text">{t('若发件服务器异常可能会导致任务异常。')}</p>
      </div>
    </TaskTemplate>
  </>
)

const TaskTemplate = styled.div`
  position: relative;
  padding-left: 20px;
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    margin-top: 10px;
  }
  .task {
    position: relative;
    z-index: 9;
    display: flex;
    align-items: center;
  }
  .task-main {
    width: 60px;
    display: flex;
    justify-content: center;
    margin: 10px 0;
  }
  .task-border {
    width: 1px;
    background: #d9d9d9;
    height: 32px;
  }
  .border-dashed {
    border: 1px dashed #f1f3f5;
  }
  .hint {
    color: #558492;
    margin-top: 10px;
  }
  .text {
    color: #666;
    margin: 0;
    margin-left: 16px;
    flex: 1;
    line-height: 1.2;
  }
  .content {
    padding: 12px;
    background-color: #f7f8f9;
    border-radius: 6px;
  }
`
const Svg = styled(SvgIcon)`
  width: 60px;
  height: 80px;
`
